import ApproachSection from './components/ApproachSection'
import FooterSection from './components/FooterSection'
import HeroSection from './components/HeroSection'
import IndustriesSection from './components/IndustriesSection'
import IntroSection from './components/IntroSection'
import ServiceScrollSection from './components/ServiceScrollSection'
import TeamSection from './components/TeamSection'

function WebsitePage() {
  return (
    <main>
      <HeroSection />
      <IntroSection />
      <ApproachSection />
      <ServiceScrollSection />
      <IndustriesSection />
      <TeamSection />
      <FooterSection />
    </main>
  )
}

export default WebsitePage
